import { HealthPlanStatuses } from '@common-fe/common-fe';

import { baseStoreCreator } from '@/utils/store';

export interface HealthPlanNamePayload {
  healthPlanName: string;
  healthPlanNotes: string;
  healthPlanStatus: HealthPlanStatuses;
  healthPlanTypes: string[];
  carrierName: string;
  carrierId: string;
  autocreateCdhEnrollment: string;
  perPersonSpendLimit: string;
  perCategorySpendLimit: string;
  parentTemplate: string;
  planYearId: string;
  planCode: string;
  plans: string[];
  planSummary: string;
}

export const DEFAULT_VALUES: HealthPlanNamePayload = {
  healthPlanName: '',
  healthPlanNotes: '',
  healthPlanStatus: HealthPlanStatuses.DRAFT,
  healthPlanTypes: [],
  carrierName: '',
  carrierId: '',
  autocreateCdhEnrollment: '',
  perPersonSpendLimit: '',
  perCategorySpendLimit: '',
  parentTemplate: '',
  planYearId: '',
  planCode: '',
  plans: [],
  planSummary: '',
};

export const useHealthPlanNameStore = baseStoreCreator<HealthPlanNamePayload>(DEFAULT_VALUES);

export default useHealthPlanNameStore;
